import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
const _excluded = ["children", "updateBreadcrumbItems"];
import React, { Component } from 'react';
import { makeBreadcrumbItemData } from '../../records/BreadcrumbsItemData';
import BreadcrumbsContext from '../BreadcrumbsContext';
export default class BreadcrumbsItemInner extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "self", null);
    _defineProperty(this, "subBreadcrumbItems", []);
    _defineProperty(this, "clearSubBreadcrumbItems", () => {
      this.subBreadcrumbItems = [];
      this.updateParent();
    });
    _defineProperty(this, "updateSubBreadcrumbItems", subBreadcrumbItems => {
      this.subBreadcrumbItems = subBreadcrumbItems;
      this.updateParent();
    });
    _defineProperty(this, "render", () => {
      return /*#__PURE__*/React.createElement(BreadcrumbsContext.Provider, {
        value: {
          clearBreadcrumbItems: this.clearSubBreadcrumbItems,
          updateBreadcrumbItems: this.updateSubBreadcrumbItems
        }
      }, this.props.children);
    });
  }
  componentDidMount() {
    this.updateSelf();
    this.updateParent();
  }
  componentDidUpdate() {
    this.updateSelf();
    this.updateParent();
  }
  componentWillUnmount() {
    this.self = null;
    this.props.clearBreadcrumbItems();
  }
  updateSelf() {
    const _this$props = this.props,
      {
        children,
        updateBreadcrumbItems
      } = _this$props,
      breadcrumbItemProps = _objectWithoutProperties(_this$props, _excluded);
    this.self = makeBreadcrumbItemData(breadcrumbItemProps);
  }
  updateParent() {
    if (this.self) {
      this.props.updateBreadcrumbItems([this.self, ...this.subBreadcrumbItems]);
    }
  }
}